(function () {
  var ROOT_SELECTOR = '[data-knee-timer], [data-nw-product-timer]';

  function padTwo(value) {
    return String(value).padStart(2, '0');
  }

  /** Milliseconds until next local midnight (timer resets daily). */
  function getMsUntilMidnight() {
    var now = new Date();
    var nextMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
    return Math.max(0, nextMidnight.getTime() - now.getTime());
  }

  function tick(root) {
    var diff = getMsUntilMidnight();
    var totalSeconds = Math.floor(diff / 1000);
    var hours = Math.floor(totalSeconds / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;

    var hoursEl = root.querySelector('[data-knee-timer-hours]');
    var minutesEl = root.querySelector('[data-knee-timer-minutes]');
    var secondsEl = root.querySelector('[data-knee-timer-seconds]');

    if (hoursEl) hoursEl.textContent = padTwo(hours);
    if (minutesEl) minutesEl.textContent = padTwo(minutes);
    if (secondsEl) secondsEl.textContent = padTwo(seconds);

    var section = root.closest('.knee-timer');
    if (section) section.hidden = false;

    return true;
  }

  function initRoot(root) {
    if (root._kneeTimerIntervalId) {
      window.clearInterval(root._kneeTimerIntervalId);
    }

    tick(root);

    root._kneeTimerIntervalId = window.setInterval(function () {
      tick(root);
    }, 1000);
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initRoot);
    document.dispatchEvent(new CustomEvent('nw:update-mobile-menu-drawer-top'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
